import { Database } from 'database';
import { OperationItem } from 'types/operation-item';
import { Alert } from 'types/alert';

export function migrateToVersion10(context: Database, transaction: IDBTransaction) {
  const me = context;
  context.readAll(context.config.indexes.Alert, transaction)
    .then(alerts => {
      alerts.forEach((alert: Alert) => {
        if (alert.item) {
          alert.item.serverRequestStarted = '';
          me.put(me.config.indexes.Alert, alert, alert.errorKey, transaction).catch();
        }
      });
    });

  migrateOperationItems(me, transaction, me.config.indexes.Complete, '');
  migrateOperationItems(me, transaction, me.config.indexes.Pending, new Date().toISOString());
}

function migrateOperationItems(context: Database, transaction: IDBTransaction, tableName: string, serverRequestStartedString: string) {
  context.readAll(tableName, transaction)
    .then(completes => {
      completes.forEach((complete: OperationItem) => {
        complete.serverRequestStarted = serverRequestStartedString;
        context.put(tableName, complete, complete.clientTransactionId.toString(), transaction).catch();
      });
    });
}


// WEBPACK FOOTER //
// ./src/migrations/1.5-1.5ODAE.ts